import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import queryString from 'query-string';

import { VEHICLE_VARIANT } from '@constants/vehicleVariant';
export const LeadCollectionContext = React.createContext();

export const LeadCollectionProvider = ({ value, children, props }) => {
  const {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    email,
    setEmail,
    phoneNumber,
    setPhoneNumber,
    country,
    setCountry,
    campaignId,
    setCampaignId,
    interestedVariants,
    setInterestedVariants,
    leadCollectionResponse,
    setLeadCollectionResponse,
  } = value || useLeadCollection();
  return (
    <LeadCollectionContext.Provider
      value={{
        firstName,
        setFirstName,
        lastName,
        setLastName,
        email,
        setEmail,
        phoneNumber,
        setPhoneNumber,
        country,
        setCountry,
        campaignId,
        setCampaignId,
        interestedVariants,
        setInterestedVariants,
        leadCollectionResponse,
        setLeadCollectionResponse,
      }}
    >
      {children}
    </LeadCollectionContext.Provider>
  );
};

export const useLeadCollection = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [country, setCountry] = useState('nl');
  const [campaignId, setCampaignId] = useState(
    queryString.parse(location.search)?.campaign
  );
  const [error, setError] = useState(false);
  const [interestedVariants, setInterestedVariants] = useState([]);
  const [leadCollectionResponse, setLeadCollectionResponse] = useState({});
  const { prefixLanguage: language } = useSelector(({ appState }) => appState);

  return {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    email,
    setEmail,
    phoneNumber,
    setPhoneNumber,
    country,
    setCountry,
    campaignId,
    setCampaignId,
    error,
    setError,
    language,
    interestedVariants,
    setInterestedVariants,
    leadCollectionResponse,
    setLeadCollectionResponse,
  };
};
